import { render, staticRenderFns } from "./CompetitionCategory.vue?vue&type=template&id=a2e430f8"
import script from "./CompetitionCategory.vue?vue&type=script&lang=js"
export * from "./CompetitionCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports